module.exports = __webpack_public_path__ + "64103a469397ba5da16acdf9b710786d.png";